import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    usernames: Array
  }

  static targets = [
    'button',
    'checkbox',
  ]

  connect() {
    if (document.body.dataset.currentUserUsername == undefined) { return }

    if (this.usernamesValue.includes(document.body.dataset.currentUserUsername)) {
      this.checkboxTarget.checked = true
    }
  }

  trigger() {
    this.buttonTarget.click()
  }

  setProperColors() {
    let totals = this.usernamesValue.length

    if (totals > 0) {
      this.element.classList.remove('bg-white')
      this.element.classList.add('bg-red-100', 'border-red-200')
    } else {
      this.element.classList.remove('bg-red-100', 'border-red-200')
      this.element.classList.add('bg-white')
    }
  }
}
